module.exports = __webpack_public_path__ + "media/images/pic/labels/b1_2-ae664f241a79fe7e4a54267a5dec0521.png";